<template>
  <div>
    <div class="b-address-container">
      <div class="b-address-container-column">
        <div class="b-address-container__user-details">
          <h3>User details</h3>
          <div>
            <div class="b-address-container__user-details__column">
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data" style="height:unset">
                  <div class="b-address-container__user-details__row-heading">Corresponding address1</div>
                  <br />

                  <div v-if="edit.corres_line1">
                    <input
                      type="text"
                      :value="details.corres_line1"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_line1'})"
                      @blur="edit.corres_line1=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_line1',$event)"
                    class="b-personal-container__user-details__text"
                    style="height:unset"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.corres_line1}}</div>
                </div>                     
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding Address2</div>
                  <br />

                  <div v-if="edit.corres_line2">
                    <input
                      type="text"
                      :value="details.corres_line2"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_line2'})"
                      @blur="edit.corres_line2=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_line2',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.corres_line2}}</div>
                </div>
              </div>

              <div class="b-address-container__user-details__row">

                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding Address3</div>
                  <br />

                  <div v-if="edit.corres_line3">
                    <input
                      type="text"
                      :value="details.corres_line3"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_line3'})"
                      @blur="edit.corres_line3=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_line3',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.corres_line3}}</div>
                </div>

                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding city</div>
                  <br />

                  <div v-if="edit.corres_city">
                    <input
                      type="text"
                      :value="details.corres_city"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_city'})"
                      @blur="edit.corres_city=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_city',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.corres_city}}</div>
                </div>



              </div>


              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding country</div>
                  <br />

                    <div v-if="edit.corres_country">
                        <input
                        type="text"
                        :value="details.corres_country"
                        class="b-personal-container__user-details__data-edit"
                        @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_country'})"
                        @blur="edit.corres_country=false"
                        :disabled="true"
                        />
                    </div>
                    <div
                        v-else
                        v-on:dblclick="changeCKycDetailHandler('corres_country',$event)"
                        class="b-personal-container__user-details__text"
                        :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                    >{{details.corres_country}}</div>
                    </div>


                  <!-- <div v-if="edit.corres_country">
                    <select
                      :value="details.corres_country"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_country'})"
                      @blur="edit.corres_country=false"
                    >
                      <option
                        v-for="country in countries"
                        :value="country"
                        :key="country"
                      >{{ country }}</option>
                    </select>
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_country',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                  >{{details.corres_country}}</div> -->
                <!-- </div> -->
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding Pincode</div>
                  <br />

                  <div v-if="edit.corres_pin">
                    <input
                      type="text"
                      :value="details.corres_pin"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_pin'})"
                      @blur="edit.corres_pin=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_pin',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.corres_pin}}</div>
                </div>
              </div>
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding State</div>
                  <br />

                  <div v-if="edit.corres_state">
                    <template>
                      <select
                      :value="state_codes[details.corres_state]"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateCKycDetail',{value: state_codes[$event.target.value],key:'corres_state'})"
                      @blur="edit.corres_state=false"
                    >
                      <option v-for="state in states" :value="state" :key="state">{{ state }}</option>
                    </select>
                    </template>
                    <!-- <template v-else>
                      <input
                      type="text"
                      :value="state_codes[details.corres_state]"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: state_codes[$event.target.value],key:'corres_state'})"
                      @blur="edit.corres_state=false"
                    />
                    </template> -->
                    
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('corres_state',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.corres_state}}</div>
                </div>
                <!-- <div class="b-address-container__user-details__row-data" style="height:unset">
                  <div class="b-address-container__user-details__row-heading">Permanent address1</div>
                  <br />

                  <div v-if="edit.perm_line1">
                    <input
                      type="text"
                      :value="details.perm_line1"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_line1'})"
                      @blur="edit.perm_line1=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_line1',$event)"
                    class="b-personal-container__user-details__text"
                    style="height:unset"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_line1}}</div>
                </div>   -->

              </div>
              <!-- <div class="b-address-container__user-details__row">
                   
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permanent Address2</div>
                  <br />

                  <div v-if="edit.perm_line2">
                    <input
                      type="text"
                      :value="details.perm_line2"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_line2'})"
                      @blur="edit.perm_line2=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_line2',$event)"
                    class="b-personal-container__user-details__text"
                    style="height:unset"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_line2}}</div>
                </div>

                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permanent Address3</div>
                  <br />

                  <div v-if="edit.perm_line3">
                    <input
                      type="text"
                      :value="details.perm_line3"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_line3'})"
                      @blur="edit.perm_line3=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_line3',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_line3}}</div>
                </div>

              </div> -->

              <!-- <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permanent city</div>
                  <br />

                  <div v-if="edit.perm_city">
                    <input
                      type="text"
                      :value="details.perm_city"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_city'})"
                      @blur="edit.perm_city=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_city',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_city}}</div>
                </div>

                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permanent country</div>
                  <br />

                  <div v-if="edit.perm_country">
                    <select
                      :value="details.perm_country"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_country'})"
                      @blur="edit.perm_country=false"
                    >
                      <option
                        v-for="country in countries"
                        :value="country"
                        :key="country"
                      >{{ country }}</option>
                    </select>
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_country',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_country}}</div>
                </div>
              </div> -->
              <!-- <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permanent Pincode</div>
                  <br />
                  <div v-if="edit.perm_pin">
                    <input
                      type="text"
                      :value="details.perm_pin"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_pin'})"
                      @blur="edit.perm_pin=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_pin',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_pin}}</div>
                </div>
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permanent State</div>
                  <br />

                  <div v-if="edit.perm_state">
                    <template v-if="details.perm_country.toUpperCase()==='INDIA'">
                      <select
                      :value="details.perm_state"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_state'})"
                      @blur="edit.perm_state=false"
                    >
                      <option v-for="state in states" :value="state" :key="state">{{ state }}</option>
                    </select>
                    </template>
                    <template v-else>
                      <input
                      type="text"
                      :value="details.perm_state"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'perm_state'})"
                      @blur="edit.perm_state=false"
                    />
                    </template>
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('perm_state',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.perm_state}}</div>
                </div>
              </div> -->
              <div class="b-address-container__user-details__row">
              </div>
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Documentation Type</div>
                  <br />

                  <div v-if="edit.ckyc_identity_type">
                    <select
                      :value="details.ckyc_identity_type"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'ckyc_identity_type'})"
                      @blur="edit.ckyc_identity_type=false"
                    >
                      <option value="passport">Passport</option>
                      <option value="voter_id_card">Voter ID Card</option>
                      <option value="driving_license">Driving License</option>
                      <option value="aadhaar">Aadhaar</option>
                      <option value="nrega_job_card">Nrega Job Card</option>
                      <option value="bank_account_statement">Bank Account Statement</option>
                      <option value="national population register letter">National Population Register Letter</option>
                      <option value="registered_sale_agreement">Registered Sale Agreement</option>
                      <option value="offline verification of aadhaar">Offline Verification of Aadhaar</option>
                      <option value="others">Others</option>
                    </select>
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('ckyc_identity_type',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.ckyc_identity_type}}</div>
                </div>
                <!-- <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Residence Status</div>
                  <br />

                  <div
                    class="b-personal-container__user-details__text"
                  >{{details.corres_country==='IN'?'Residence Individual':'Non Residence Individual'}}</div>
                </div> -->

                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Identity Number</div>
                  <br />

                  <div v-if="edit.ckyc_identity_number">
                    <input
                      type="text"
                      :value="details.ckyc_identity_number"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'ckyc_identity_number'})"
                      @blur="edit.ckyc_identity_number=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('ckyc_identity_number',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.ckyc_identity_number}}</div>
                </div>

              </div>
              <div class="b-address-container__user-details__row">
                <div
                  class="b-address-container__user-details__row-data"
                  v-if="details.ckyc_identity_type=='passport' || details.ckyc_identity_type=='driving_license'"
                >
                  <div
                    class="b-address-container__user-details__row-heading"
                  >Validity of provided address proof</div>
                  <br />

                  <div v-if="edit.validity_doc_poa_corr">
                    <input
                      type="date"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'validity_doc_poa_corr'})"
                      @blur="edit.validity_doc_poa_corr=false"
                      :value="details.validity_doc_poa_corr"
                      :disabled="true"
                    />
                    <!-- <DatePicker
                    format="dd MMM yyyy"
                    input-class="b-personal-container__user-details__data-edit"
                    placeholder="Select Validity of address proof"
                    @selected="updateDate"
                    @closed="closedDatePicker"
                    :value="details.validity_doc_poa_corr"
                    :clear-button="true"
                    clear-button-icon="fa fa-times-circle"
                    /> -->
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('validity_doc_poa_corr',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.validity_doc_poa_corr}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--------------NRI Passport Details-------->
        <!-- <div
          class="b-address-container__user-details"
          v-if="details.residence_status==='non_resident_individual'"
        >
          <h3>NRI Passport Details</h3>
          <div>
            <div class="b-address-container__user-details__column">
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Passport Number</div>
                  <br />

                  <div v-if="edit.passport_reference_id">
                    <input
                      type="text"
                      :value="details.passport_reference_id"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'passport_reference_id'})"
                      @blur="edit.passport_reference_id=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('passport_reference_id',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor':getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.passport_reference_id}}</div>
                </div>
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Validity of passport</div>
                  <br />

                  <div v-if="edit.passport_validity_date">
                    <input
                      type="date"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'passport_validity_date'})"
                      @blur="edit.passport_validity_date=false"
                      :value="details.passport_validity_date"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeCKycDetailHandler('passport_validity_date',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                  >{{details.passport_validity_date}}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="b-address-container__form" v-if="getCKycStatusForApproval">
          <div class="b-address-container__form_row">
            <input
              type="checkbox"
              id="address"
              value="address"
              :checked="checkDetails['address_status']"
              @change="$emit('checkDetail', 'address_status')"
            />
            <label for="address">Address is as per the uploaded document</label>
            <br />
          </div>
          <div class="b-address-container__form_row" v-if="details.ckyc_identity_type=='passport' || details.ckyc_identity_type=='driving_license'">
            <input
              type="checkbox"
              id="address_validity"
              value="address_validity"
              :checked="checkDetails['address_validity']"
              @change="$emit('checkDetail', 'address_validity')"
            />
            <label for="address_validity">Address Validity Date is as per the uploaded document</label>
            <br />
          </div>

        </div>
        <div class="b-address-container__btn">
          <div v-if="editFlag">
            <button class="b-global__button" @click="updateInfo">Save Changes</button>
          </div>
          <button @click="checkEditDetails();" class="b-global__button">NEXT</button>
          <div v-if="showModal">
            <Modal @closeModal="showModal= false" @goNext="$emit('goNext') "></Modal>
          </div>
        </div>
      </div>
      <div class="b-address-container-column">
        <h3>User Proof</h3>
        <div class="b-address-container__img">
          <!-- <img
            v-bind:src="details.url_poa_corr_side1"
            alt="Proof of address side 1"
            style="width:100%"
          /> -->
        <iframe
            
            v-bind:src="details.url_poa_corr_side1"
            frameborder="0"
            style="width:350px; height:400px;"
        >
        </iframe>
          <div class="b-personal-container__img-section">
            <p>Proof of address</p>
            <div class="b-personal-container__btn-container" v-if="getCKycStatusForApproval">
              <div>
                <button
                  @click="rotateImage('url_poa_corr_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
                <div>
                <button
                  @click="maskImage('url_poa_corr_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >MASK</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_poa_corr_side1',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>              
            </div>
            <div >
                <p>Size</p>
                {{getFileSize(details.url_poa_corr_side1)}}
            </div>              
          </div>
        </div>
        <!-- <div class="b-address-container__img">
          <img v-bind:src="details.url_poa_corr_side2" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Proof of address side 2</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_poa_corr_side2')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
                  <div>
                <button
                  @click="maskImage('url_poa_corr_side2')"
                  class="b-global__button b-personal-container__edit-btn"
                >MASK</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_poa_corr_side2',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div
          class="b-address-container__img"
          v-if="details.residence_status==='non_resident_individual'"
        >
          <img v-bind:src="details.url_passport_side1" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Passport image side 1</p>
            <div class="b-personal-container__btn-container" v-if="getCKycStatusForApproval">
              <div>
                <button
                  @click="rotateImage('url_passport_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_passport_side1',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div
          class="b-address-container__img"
          v-if="details.residence_status==='non_resident_individual'"
        >
          <img v-bind:src="details.url_passport_side2" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Passport image side 2</p>
            <div class="b-personal-container__btn-container" v-if="getCKycStatusForApproval">
              <div>
                <button
                  @click="rotateImage('url_passport_side2')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_passport_side2',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "../../commons/modal-ckyc.vue";
import states from "../../commons/states-code-ckyc.json";
import countries from "../../commons/countries.json";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: { Modal },
  data() {
    return {
      edit: {
        corres_line1: false,
        corres_line2: false,
        corres_line3: false,
        corres_city: false,
        corres_country: false,
        corres_pin: false,
        residence_status: false,
        corres_state: false,
        validity_doc_poa_corr: false,
        ckyc_identity_type: false,
        permanent_address: false,
        permanent_pincode: false,
        permanent_country: false,
        permanent_state: false,
        permanent_city: false,
        passport_validity_date: false,
        passport_reference_id: false
      },
      showModal: false,
      states: Object.keys(states.states[0]),
      state_codes: states.states[0],
      countries: countries.countries
    };
  },
  props: {
    checkDetails: {
      type: Object
    },

    details: {
      type: Object,
      required: true
    },
    editFlag: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters(["getCKycStatusForApproval"]),
  },

  methods: {
    checkedNames: function(element) {
      let array = ["Address", element];
      this.$emit("checkedBox", array);
    },
    showEditHandler(value) {
      this.edit[value] = !this.edit[value];
    },
    updateInfo() {
      let obj = {};
      obj.data = this.$store.state.ckycDetails.userCkycData;
      obj.id = this.$route.params.id;
      if (obj.data.hasOwnProperty("error_message"))
        delete obj.data.error_message;
      this.$store.dispatch("updateCKycDetail", obj);
      this.$emit("changeEditFlag", false);
    },
    changeCKycDetailHandler(editInfo, event) {
      if (this.getCKycStatusForApproval) {
        this.edit[editInfo] = !this.edit[editInfo];
        this.$emit("changeEditFlag", true);
      } else {
        event.preventDefault();
      }
    },
    checkEditDetails() {
      if (this.editFlag) this.showModal = true;
      else this.$emit("goNext");
    },
    handleUploadFile: function(key, evt) {
      let files = evt.target.files || evt.dataTransfer.files;
     
      this.$store.dispatch("uploadFileCkyc", {
        file: files[0],
        id: this.$route.params.id,
        key: key
      });
    },
    rotateImage(element) {
        let element_param = element + '_image'
        this.$store.dispatch("ckycDetailsByID", { id: this.$route.params.id, images_required: element } ).then(() => {      
            this.$store.commit("setcroppedImgUrl", this.details[element_param]);
            this.$router.push({
                name: "ckyc-details-edit-img",
                params: {
                id: this.$route.params.id,
                imgname: element
                }
            });
        })
    },
    maskImage(element){
        let element_param = element + '_image'
        this.$store.dispatch("ckycDetailsByID", { id: this.$route.params.id, images_required: element } ).then(() => {          
            this.$store.commit("setcroppedImgUrl", this.details[element_param]);
            this.$router.push({
                name: "ckyc-details-mask-img",
                params: {
                id: this.$route.params.id,
                imgname: element
                }
            });
        })
    },
      updateDate(date){
        this.$store.commit('updateCKycDetail',{value: moment(date).format("DD/MM/YYYY"),key:'validity_doc_poa_corr'})
    },
    closedDatePicker(){
      this.edit.validity_doc_poa_corr=false;
    },
    getFileSize(url)
    {
        var fileSize = '';
        var http = new XMLHttpRequest();
        http.open('HEAD', url, false); // false = Synchronous

        http.send(null); // it will stop here until this http request is complete

        // when we are here, we already have a response, b/c we used Synchronous XHR

        if (http.status === 200) {
            fileSize = http.getResponseHeader('content-length');
            console.log('fileSize = ' + fileSize);
        }

        return this.formatSizeUnits(fileSize);
    },

    formatSizeUnits(bytes){
        if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
        else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
        else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
        else if (bytes > 1)           { bytes = bytes + " bytes"; }
        else if (bytes == 1)          { bytes = bytes + " byte"; }
        else                          { bytes = "0 bytes"; }
        return bytes;
    }
  }
};
</script>

<style scoped>
.b-address-container {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
.b-address-container__img {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  margin-bottom: 25px;
}

.b-address-container__form button {
  margin-top: 15px;
}
.b-address-container__form {
  margin-top: 25px;
  text-align: left;
}
.b-address-container__error {
  color: #d8000c;
}
.b-address-container__form label {
  margin-left: 15px;
}

.b-address-container__form_row {
  /* border-bottom: solid 1px #e0e0e0; */
  padding-top: 10px;
}

.b-address-container__img-label {
  text-align: center;
  margin-top: 10px;
}
.b-address-container__user-details {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.b-address-container-column {
  display: flex;
  flex-direction: column;
  margin: 30px;
}
.b-address-container-column h3 {
  display: flex;
  justify-content: center;
}
.b-address-container__user-details__column {
  display: flex;
  flex-direction: column;
}
.b-address-container__user-details__row {
  display: flex;
}
.b-address-container__user-details__row-heading {
  min-width: 275px;
  font-weight: 600;
}

.b-address-container__user-details__row-data {
  padding: 10px;
  width: 328px;
  margin: 10px;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  height: 80px;
}
.edit,
.save {
  width: 15px;
  height: 16px;
  object-fit: contain;
}
.b-address-container__user-details__edit {
  display: flex;
}
.b-address-container__user-details__data {
  white-space: nowrap;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  width: 250px;
  text-overflow: ellipsis;
}
.b-address-container__user-details__data-edit {
  width: 100%;
  border: none;
}
.b-address-container__btn {
  display: flex;
  justify-content: center;
}
.b-personal-container__user-details__text {
  height: 18px;
}
.b-personal-container__user-details__data-edit {
  width: 90%;
  font-size: 16px;
  padding: 4px;
}
.b-personal-container__img-section {
  text-align: center;
}
.b-personal-container__upload {
  cursor: pointer;
  position: relative;
  margin-top: 13px;
}
.b-personal-container__upload-input {
  -webkit-appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.b-perosnal-conatiner__upload-text {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  padding-left: 10px;
  letter-spacing: normal;
  text-align: center;
  color: #00bfff;
}
.b-personal-container__user-details__data-edit__select {
  border: none;
  background: none;
  font-size: 16px;
  width: 100%;
}
.b-personal-container__edit-btn {
  margin: unset !important;
}
.b-personal-container__btn-container {
  display: flex;
  justify-content: space-evenly;
}
</style>